import 'dayjs/locale/ja'

import { DatePickerInput as MantineDatePickerInput, DatePickerProps } from '@mantine/dates'
import Holidays from 'date-holidays'

import { calcDay, calcYear } from '../utils/date'

interface DatePickerInputProps {
  className?: string
  locale?: string
  label: string
  value: Date | null | undefined
  onChange: (value: Date | null) => void
}

const maxDate = calcDay(new Date(), -1)
const minDate = calcYear(new Date(), -2)

const dayRenderer: DatePickerProps['renderDay'] = (date) => {
  const hd = new Holidays('JP')
  const day = date.getDate()
  const isHoliday = hd.isHoliday(date)
  return isHoliday ? <div className='text-[#FA5252]'>{day}</div> : day
}

function DatePickerInput({ className, locale, label, value, onChange }: DatePickerInputProps) {
  return (
    <MantineDatePickerInput
      className={`w-[215px] ${className}`}
      locale={locale}
      label={label}
      placeholder='選択してください'
      valueFormat='YYYY/MM/DD'
      value={value}
      renderDay={dayRenderer}
      minDate={minDate}
      maxDate={maxDate}
      onChange={onChange}
      clearable
    />
  )
}

DatePickerInput.defaultProps = {
  className: '',
  locale: 'ja',
}

export default DatePickerInput
